/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferConstructionSiteInfoResponse } from '../../models/offer-construction-site-info-response';

export interface GetOfferConstructionSiteInfo$Params {
  id: number;
}

export function getOfferConstructionSiteInfo(http: HttpClient, rootUrl: string, params: GetOfferConstructionSiteInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferConstructionSiteInfoResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferConstructionSiteInfo.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferConstructionSiteInfoResponse>;
    })
  );
}

getOfferConstructionSiteInfo.PATH = '/offers/{id}/construction-site-info';
